import { useState, useEffect } from 'react'

export const useCooldown = (initialCooldown: number) => {
  const [cooldown, setCooldown] = useState(0)

  useEffect(() => {
    if (cooldown > 0) {
      const timer = setTimeout(() => {
        setCooldown(cooldown - 1)
      }, 1000)

      return () => clearTimeout(timer)
    }
  }, [cooldown])

  const startCooldown = () => {
    setCooldown(initialCooldown)
  }

  return { cooldown, startCooldown }
}
